/** @format */
import { Injectable } from '@angular/core';
import { ValidatablePlan } from 'common-typescript';
import { CourseUnit, CustomStudyDraft, LocalId, Module, OtmId } from 'common-typescript/types';

@Injectable()
export class ModuleDescendantService {
    /**
     * Returns course units that are selected in the given plan under the given module.
     * If a course unit is substituted, the substituting course unit is returned instead.
     */
    getCourseUnitsForModuleRecursively(module: Module, validatablePlan: ValidatablePlan): Set<CourseUnit> {
        const recursiveResult = new Map<OtmId, CourseUnit>();

        function recurse(currentModule: Module): void {
            for (const courseUnit of validatablePlan.getCourseUnitsOrSubstitutingCourseUnitsForModule(currentModule)) {
                if (!recursiveResult.has(courseUnit.id)) {
                    recursiveResult.set(courseUnit.id, courseUnit);
                }
            }

            validatablePlan.getSelectedModulesUnderModule(currentModule).forEach(recurse);
        }

        recurse(module);

        return new Set<CourseUnit>(recursiveResult.values());
    }

    /**
     * Returns custom study drafts that are selected in the given plan under the given module.
     */
    getCustomStudyDraftsForModuleRecursively(module: Module, validatablePlan: ValidatablePlan): Set<CustomStudyDraft> {
        const recursiveResult = new Map<LocalId, CustomStudyDraft>();

        function recurse(currentModule: Module): void {
            for (const customStudyDraft of validatablePlan.getSelectedCustomStudyDraftsByParentModuleId(currentModule.id)) {
                if (!recursiveResult.has(customStudyDraft.id)) {
                    recursiveResult.set(customStudyDraft.id, customStudyDraft);
                }
            }

            validatablePlan.getSelectedModulesUnderModule(currentModule).forEach(recurse);
        }

        recurse(module);

        return new Set<CustomStudyDraft>(recursiveResult.values());
    }
}
